module.exports = __webpack_public_path__ + "static/media/pnln-send-your-story-tips.dab56afe.png";